import { POSITION_LATLNG} from './positionTypes'

const initialState = {
    position: []
}

const positionReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case POSITION_LATLNG:
            
            return {
                position: action.load
            }
    
        default:
          return state
    }

}


export default positionReducer;